
import React from "react";
import { cn } from "../../../../../../utils/classnames";
import { useBookingEditText } from "../../../text";
import { InfoIcon } from "../../../../../../components/icons"

const CancellationFeeInformation = ({
    getTypographyClass,
    editFeeCalculation: {
        totalPriceCancellation = 0,
        desc,
        totalFee = 0,
        totalMeetAssistCancellation = 0,
        meetAssistCancelDesc,
        meetAssistCancelFee = 0,
        refundAmount,
    },
    paymentStatus,
    deferredPayment,
    newBookingTotalPrice,
    openPolicyModal,
    changes,
    oldBookingPrice,
    meetAssistChangesIdentification
}) => {
    const { t, language = "en" } = useBookingEditText();

    const isHigherPrice = (totalFee + meetAssistCancelFee + newBookingTotalPrice) > oldBookingPrice;

    const getRefundAmountDetails = () => {
        return `(= ${(oldBookingPrice - newBookingTotalPrice).toLocaleString()}${t("editBooking.BookingReviewPage.jpy")} - ${(totalFee + meetAssistCancelFee.arrival + meetAssistCancelFee.departure).toLocaleString()}${t("editBooking.BookingReviewPage.jpy")})`;
    }

    const getAdditionalFee = () => {
        return {
            fee: `${((newBookingTotalPrice + totalFee + meetAssistCancelFee.arrival + meetAssistCancelFee.departure) - oldBookingPrice)?.toLocaleString() || 0}${t("editBooking.BookingReviewPage.jpy")}`,
            details: `(= ${(newBookingTotalPrice - oldBookingPrice)?.toLocaleString() || 0}${t("editBooking.BookingReviewPage.jpy")} + ${(totalFee + meetAssistCancelFee.arrival + meetAssistCancelFee.departure)?.toLocaleString()}${t("editBooking.BookingReviewPage.jpy")})`
        }
    }

    function detectDowngradeMeetAssist() {

        console.log("totalMeetAssistCancellation", totalMeetAssistCancellation);
        console.log("meetAssistChangesIdentification", meetAssistChangesIdentification)
        if (totalMeetAssistCancellation <= 0) return { departure: false, arrival: false };



        const tier = {
            none: 0,
            meetAssist: 1,
            vipMeetAssist: 2,
        };

        const result = {};

        const oldMap = Object.fromEntries(
            meetAssistChangesIdentification?.old?.map(item => [item.meetAssistType, item]) ?? []
        );

        const newMap = Object.fromEntries(
            meetAssistChangesIdentification?.new?.map(item => [item.meetAssistType, item]) ?? []
        );

        console.log("oldMap", oldMap);
        console.log("newMap", newMap);

        ["arrival", "departure"].forEach(type => {
            const oldItem = oldMap[type];
            const newItem = newMap[type];

            if (!oldItem || !newItem) return;

            const oldTier = tier[oldItem.meetAssistName] ?? 0;
            const newTier = tier[newItem.meetAssistName] ?? 0;

            console.log('oldTier', type, oldItem.meetAssistName, oldTier);
            console.log('newTier', type, newItem.meetAssistName, newTier);

            if (newTier < oldTier) {
                result[type] = true;
            }
        });

        return result;
    }

    const getUpdatedBookingFeeDeferred = () => {
        const cancellationFee = (totalFee || 0) + (meetAssistCancelFee.arrival || 0) + (meetAssistCancelFee.departure || 0)
        return `(= ${((newBookingTotalPrice || 0)).toLocaleString()}${t("editBooking.BookingReviewPage.jpy")} + ${(cancellationFee).toLocaleString()}${t("editBooking.BookingReviewPage.jpy")})`;
    }

    return (
        <section className="tw:w-full tw:flex tw:flex-col tw:gap-4">
            <div>
                <div className="tw:text-[#4e4e4e] tw:text-[16px] tw:font-[700]">{t("editBooking.BookingReviewPage.cancellationFeeInformation.title")}</div>
            </div>

            <div
                className={cn(
                    "tw:w-[calc(100%+32px)] tw:-mx-4 tw:sm:mx-0 tw:sm:w-full tw:border tw:border-[#e8e8e8] tw:sm:rounded-[5px] tw:bg-white tw:overflow-hidden",
                    getTypographyClass(14)
                )}
            >
                {/* Schedule Change Row */}
                {
                    totalPriceCancellation > 0 && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t(`editBooking.BookingReviewPage.cancellationFeeInformation.${changes?.travelDate?.changed ? "reservationDateChange" : "scheduleChangeWithinTheReservationDate"}`)}</p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.cancellationFee")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{totalFee?.toLocaleString()}{t("editBooking.BookingReviewPage.jpy")}</p>
                                </div>

                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.cancellationRate")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{language === "en" ? desc.en : desc.jp}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                {/* Meet & Assist Row */}
                {
                    detectDowngradeMeetAssist().arrival && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t(`editBooking.BookingReviewPage.cancellationFeeInformation.${meetAssistCancelDesc?.arrival?.type === "vipMeetAssist" ? "arrivalVipMeetAssistServiceCancellation" : "arrivalMeetAssistServiceCancellation"}`)}</p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className={`tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0`}>
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.meetAssistServiceCancellationFee")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{meetAssistCancelFee?.arrival?.toLocaleString()}{t("editBooking.BookingReviewPage.jpy")}</p>
                                </div>

                                <div className={`tw:w-full tw:lg:w-1/3 tw:lg:flex-1 tw:pl-5 tw:md:pl-7`}>
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.meetAssistServiceCancellationRate")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{language === "en" ? meetAssistCancelDesc?.arrival?.en : meetAssistCancelDesc?.arrival?.jp}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    detectDowngradeMeetAssist().departure && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t(`editBooking.BookingReviewPage.cancellationFeeInformation.${meetAssistCancelDesc?.departure?.type === "vipMeetAssist" ? "departureVipMeetAssistServiceCancellation" : "departureMeetAssistServiceCancellation"}`)}</p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className={`tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0`}>
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.meetAssistServiceCancellationFee")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{meetAssistCancelFee?.departure?.toLocaleString()}{t("editBooking.BookingReviewPage.jpy")}</p>
                                </div>

                                <div className={`tw:w-full tw:lg:w-1/3 tw:lg:flex-1 tw:pl-5 tw:md:pl-7`}>
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.meetAssistServiceCancellationRate")}</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{language === "en" ? meetAssistCancelDesc?.departure?.en : meetAssistCancelDesc?.departure?.jp}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                {/* Total Row */}
                <div className="tw:flex tw:w-full tw:p-4 tw:bg-[#f9f9f9]">
                    <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                        <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.total")}</p>
                    </div>
                    <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                        <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                            <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.totalCancellationFee")}</p>
                            <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{((totalFee || 0) + (meetAssistCancelFee.arrival || 0) + (meetAssistCancelFee.departure || 0))?.toLocaleString()}{t("editBooking.BookingReviewPage.jpy")}</p>
                        </div>
                        {
                            deferredPayment ? (
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.updatedBookingFee")}</p>
                                    <div className="tw:!flex tw:!items-baseline tw:!gap-1">
                                        <span className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{((totalFee || 0) + (meetAssistCancelFee.arrival || 0) + (meetAssistCancelFee.departure || 0) + (newBookingTotalPrice || 0))?.toLocaleString()}{t("editBooking.BookingReviewPage.jpy")}</span>
                                        <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{getUpdatedBookingFeeDeferred()}</span>
                                    </div>
                                </div>
                            ) : (
                                isHigherPrice ? (
                                    <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                        <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{refundAmount === 0 ? t("editBooking.BookingReviewPage.cancellationFeeInformation.additionalFee") : t("editBooking.BookingReviewPage.cancellationFeeInformation.refundAmount")}</p>
                                        <div className="tw:!flex tw:!items-baseline tw:!gap-1">
                                            <span className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{getAdditionalFee().fee}</span>
                                            <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{getAdditionalFee().details}</span>
                                        </div>
                                        {
                                            refundAmount > 0 && (
                                                <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:italic tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.processAfterTransferCompleted")}</p>
                                            )
                                        }
                                    </div>
                                ) : (
                                    <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                        <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{refundAmount === 0 ? t("editBooking.BookingReviewPage.cancellationFeeInformation.refund") : t("editBooking.BookingReviewPage.cancellationFeeInformation.refundAmount")}</p>
                                        {
                                            refundAmount === 0 ? (
                                                <p className="tw:!text-[#A7A7A7] tw:!font-[400] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.0JPY")}</p>
                                            ) : (
                                                <div className="tw:!flex tw:!items-baseline tw:!gap-1">
                                                    <span className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{`${refundAmount?.toLocaleString()}${t("editBooking.BookingReviewPage.jpy")}`}</span>
                                                    <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px] tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{getRefundAmountDetails()}</span>
                                                </div>
                                            )
                                        }
                                        {
                                            refundAmount > 0 && (
                                                <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:italic tw:!mb-0 w:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.cancellationFeeInformation.processAfterTransferCompleted")}</p>
                                            )
                                        }
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>

            <div className="tw:flex tw:gap-4">
                <button
                    type="button"
                    onClick={openPolicyModal}
                    className="tw:w-full tw:md:w-auto tw:flex tw:items-center tw:justify-center tw:gap-2 tw:px-6 tw:py-2 tw:!rounded-[5px] tw:!bg-[#F1F1F1]"
                >
                    <InfoIcon
                        color="#7C7B7B"
                        size={14}
                        className="tw:shrink-0"
                    />
                    <span className="tw:!text-[#4E4E4E] tw:!text-[14px] tw:!font-[400]">
                        {t("editBooking.BookingReviewPage.cancellationFeeInformation.cancellationPolicy")}
                    </span>
                </button>
            </div>
        </section>
    );
}

export default CancellationFeeInformation;
